import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { DocumentLevel } from 'providers/DocumentLevel';
export var Heading = function Heading(_ref) {
  var children = _ref.children,
      className = _ref.className,
      attrs = _objectWithoutProperties(_ref, ["children", "className"]);

  return React.createElement(DocumentLevel.Consumer, null, function (level) {
    var Tag = level > 6 ? 'p' : "h".concat(level);
    var tagClass = classNames(className, level > 6 && "h".concat(level));
    return React.createElement(Tag, _extends({}, attrs, {
      className: tagClass
    }), children);
  });
};
Heading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};